import { useGet } from '../../HttpClient';
import { AccountFlagDefinitionModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";

export function useAccountFlagDefinitions() {
  const get = useGet(true, pillarCode);
  const getAccountFlagDefinitions = (): Promise<AccountFlagDefinitionModel[]> =>
      get(`${referenceDataBaseUrl}/account-flag-definitions`);
  return useQueryWithErrorHandling({
    queryKey: ["get-account-flag-definitions"],
    queryFn: async () => await getAccountFlagDefinitions(),
  });
}

export function useRefreshAccountFlagDefinitions() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: ['get-account-flag-definitions'] });
}